import React from 'react';

import { Text } from '@auspost/postmaster-react';

import { useArticles, useShipment } from '../hooks/shipment.hooks';
import DeliveryAddress from './DeliveryAddress/DeliveryAddress';
import DeliveryInstructions from './DeliveryInstructions/DeliveryInstructions';
import InfoRow from './InfoRow/InfoRow';
import ServiceFeatures from './ServiceFeatures/ServiceFeatures';
import SizeWeight from './SizeWeight/SizeWeight';
import { DETAILS_PANEL_TEST_ID, TRACKING_NUMBER_TEST_ID } from './DetailsPanel.test-ids';

import styles from './DetailsPanel.module.scss';

export const DetailsPanel: React.FC = () => {
  const articles = useArticles();
  const consignmentId = useShipment()?.consignmentId ?? '';

  const displayTrackingNumber = () => {
    if (articles.length === 1) return articles[0].articleId;
    return (
      <>
        <span className={styles.consignmentId}>
          {consignmentId} {`(${articles?.length} Parcels) `}
        </span>
        {Object.values(articles).map((article, index) => (
          <span key={index}>
            Parcel {index + 1}: {article.articleId} <br />
          </span>
        ))}
      </>
    );
  };

  return (
    <div className={styles.detailsPanel} data-testid={DETAILS_PANEL_TEST_ID}>
      <InfoRow heading='Tracking number'>
        <Text variant='body-small' className={styles.textContent} data-testid={TRACKING_NUMBER_TEST_ID}>
          {displayTrackingNumber()}
        </Text>
      </InfoRow>
      <div className={styles.divider} />

      <DeliveryAddress />

      <DeliveryInstructions />

      <InfoRow heading='Service and features'>
        <ServiceFeatures />
      </InfoRow>
      <div className={styles.divider} />

      <InfoRow heading='Size and weight'>
        <SizeWeight />
      </InfoRow>
    </div>
  );
};

export default DetailsPanel;
